/**
 * This is mostly used for filtering with using more than one predicate, in example:
 *
 * [{name: 'Bob', age: 43}, {name: 'John', age: 20}].filter(anyPass([hasAgeAbove(25), isNamed('John')]))
 * >>> [{name: 'Bob', age: 43}, {name: 'John', age: 20}]
 */
export function anyPass<T>(predicates: Array<(a: T) => boolean>): (value: T) => boolean {
    return (value: T): boolean => {
        return predicates.some((predicate) => predicate(value))
    }
}
